module.exports = __webpack_public_path__ + "static/media/duplicate-green.c22bf559.svg";